export function mirrorValueInRange(value: number, max = 100, min = 0) {
  return max + min - value;
}
